import BaseValidator from 'services/validations/base-validator';

class KeyPlayerValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking, players, playersExclusion, playersFilters} = this.dependencies;
        const items = stacking.getItems();

        items.forEach((item) => {
            const keyPlayerId = item.getKeyPlayerId();

            if (!keyPlayerId) {
                this.addError('Please choose a QB player.');
                return;
            }

            const player = players.getPlayer(item.getKeyPlayerId());

            if (player.isExcludedAnywhere(playersExclusion) || !inArray(player.team, playersFilters.games)) {
                this.addError(`Player ${player.name} is excluded.`);
            }
        });
    }
}

export default KeyPlayerValidator;
